import React from 'react';

import { getOrganizationRootContentId } from '@gitbook/app-hive';
import { useHiveClient } from '@gitbook/hive-react';

import { type GitBookAgentClient, useAgent } from '../Agent';

type SiteFindingAgentParams = {
    organizationId: string;
    siteId: string;
    siteFindingId: string;
};

export type AgentFindingProcessorClient = GitBookAgentClient<{}>;

/**
 * Hook to connect to the site finding processor agent.
 */
export function useSiteFindingAgent(input: SiteFindingAgentParams): AgentFindingProcessorClient {
    const { organizationId, siteId, siteFindingId } = input;
    const hiveClient = useHiveClient();

    // Cast via unknown: GitBookAgentClient's RPC generic trips TypeScript 7's
    // instantiation-depth limit (TS2589) when checked against the return type.
    return useAgent({
        pathname: `/agents/o/${organizationId}/sites/${siteId}/findings/${siteFindingId}`,
        getToken: React.useCallback(
            () => hiveClient.auth.getToken(getOrganizationRootContentId(organizationId)),
            [hiveClient, organizationId]
        ),
    }) as unknown as AgentFindingProcessorClient;
}
